module.exports = __webpack_public_path__ + "static/media/icon-supplies-brush.e096652a.svg";